module.exports = __webpack_public_path__ + "static/media/filter-gray.66362558.svg";